import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MountainLake2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_LAKE2;
}

export default MountainLake2PoiTileEntity;
